window.VegasShop.Fav = {
	requestPost: function (method, params, callback = {}) {
		params['_token'] = App.csrf;

		$.post('/fav/' + method, params, function (data) {
			if ('afterSend' in callback) {
				callback.afterSend(data);
			}

			VegasShop.Fav.total(data);
		});
	},
	add: function ($self) {
		/*if (!App.user.isAuth) {
			$self.blur();
			$("#modal-account-auth").modal('show');

			return;
		}*/

		$self.attr('data-action', 'del');

		let $prd = $self.closest('[data-cart=product]');
		let id = $prd.data('id');

		this.requestPost('add_product', {id: id}, {
			afterSend: function (data) {

				$('[data-cart=product][data-id="' + data.product.id + '"]').addClass('in-fav');
			}
		});
	},
	del: function ($self) {
		let $prd = $self.closest('.vg-shop-prd');
		let id = $prd.data('id');
		$self.attr('data-action', 'add');

		this.requestPost('del_product', {id: id}, {
			afterSend: function (data) {
				$('.vg-shop-prd[data-id="' + data.product.id + '"]').removeClass('in-fav');
				$('.cart-prd[data-id="' + data.product.id + '"]').fadeOut();
			}
		});
	},

	total: function (data) {
		if (data.products_count !== 'undefined') {
			$('[data-fav][data-counter="products-count"]').attr('data-cnt', data.products_count);
		}
	}
};

(function ($) {
	$(document).on('click', '[data-fav][data-action=add]', function () {
		VegasShop.Fav.add($(this));
		return false;
	});

	$(document).on('click', '[data-fav][data-action=del]', function () {
		VegasShop.Fav.del($(this));
		return false;
	});
})(jQuery);
